import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const { customerNumber } = CommonParameters;

export const lpgPaymentFrequencyMethod: IMcAppType = {
  name: "lpgPaymentFrequencyMethod",
  path: "/my/payment-settings/lpg/frequency",
  parameters: {
    properties: { customerNumber },
  },
  description: "Payment frequency for a given customer number",
  navFlow: NavFlow.FOCUS,
  title: "Payment frequency",
  parent: Tab.MORE,

  conditions: {
    intent: "lpgPaymentFrequencyMethod",
  },
};
